import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Text, TextType } from 'ui-components/components/text';

import { useSelectedBasePlan } from '../../../hooks/use-plan-details';
import { PriceValue } from '../../price-value';

import { messages } from './messages';
import collapsibleStyle from '../collapsible/collapsible.module.css';
import { useLocalizedPlanName } from '../../plan-name-helper';

export const CollapsiblePlanSubscriptionHeader = () => {
  const selectedPlan = useSelectedBasePlan();
  const planName = useLocalizedPlanName(selectedPlan?.name);
  return (
    <div className={collapsibleStyle['header-text-wrapper']}>
      <Text textType={TextType.H3} value={<FormattedMessage {...messages.planSelectionTitle} />} />
      <div className={collapsibleStyle['header-price']}>
        <Text className={collapsibleStyle['header-selected-state-label']} textType={TextType.Caption} value={planName} />
        <Text textType={TextType.H3} value={<PriceValue plan={selectedPlan} />} />
      </div>
    </div>
  );
};
